import React from 'react'
import css from './style.scss'
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import api from '../api'
import moment from 'moment'
import Stats from './stats'
import DatePicker from 'components/shared/datePicker'
import analytics from 'utils/analytics'

class StatsSection extends React.Component{
  constructor(props){
    super(props)
    this.state={
      loading:true,
      stories:[],
      startDate:moment().subtract(6,"days").startOf("day"),
      endDate:moment().endOf("day"),
    }
  }
  loadStories(){
    api.getStories(
      this.props.account,
      {
        startDate:this.state.startDate.format("YYYY-MM-DD"),
        endDate:this.state.endDate.format("YYYY-MM-DD")
      },
      false
    ).then(stories=>{
      this.setState({stories})
    })
  }
  componentDidMount(){
    analytics.track("view_stats")
    this.loadStories()
  }
  handleDates=({startDate,endDate})=>{
    this.setState({
      startDate,
      endDate
    }, this.loadStories)
  }
  render(){
    return (
      <div>
        <div className={css.head}>
          <h3>Stats</h3>
          <DatePicker
            className={css.datePicker}
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            onDatesChange={this.handleDates}
            blockBefore={this.props.account.all_access ? moment(this.props.account.created_at) : moment().subtract(7,"days")}
          />
        </div>
        <Stats
          stories={this.state.stories}
          startDate={this.state.startDate}
          endDate={this.state.endDate}
        />
      </div>
    )
  }
}

const mapStateToProps = function (state, props) {
  let account=state.accounts[props.match.params.id]
  return {account};
}

export default connect(mapStateToProps)(withRouter(StatsSection));



// WEBPACK FOOTER //
// ./src/components/account_page/stats/index.js